module.exports = __webpack_public_path__ + "static/media/2.34bc056b.jpg";